import styled from "styled-components";

const Container = styled.div`
  grid-template-columns: 1fr 1fr;
  grid-gap: 20px;
`;
const BoxContainer = styled.div`
  border-radius: 15px;
  border: solid 1px #87cdf1;
  overflow: hidden;
  margin-top: 7px;
  box-shadow: 0 9px 8px 0 rgb(0 0 0 / 16%);
`;
const InfoDetailWrapper = styled.div`
  /* display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr)); */
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
`;
const InfoHeading = styled.div`
  font-family: "latobold";
`;
const InfoDetail = styled.div`
  font-size: 15px;
  margin: 5px 0;
  .payment-info-div {
    background-color: #e4e4e494;
    padding: 1px 0px 1px 8px;
    border-radius: 5px;
    margin-top: 5px;
  }
`;
const Heading = styled.div`
  background-color: #87cdf1;
  font-size: 17px;
  color: #ffffff;
  padding: 11px 16px;
  overflow: hidden;
  .info-tooltip-ul {
    max-width: 100%;
    text-align: left;
  }
`;

const InfoWrapperBox = styled.div`
  padding: 10px 10px 10px 15px;
  min-width: 200px;
  a{
    color: #007bff;
  }
`;
export {
  Container,
  BoxContainer,
  InfoDetailWrapper,
  InfoHeading,
  InfoDetail,
  Heading,
  InfoWrapperBox,
};
